<template>
    <div>
        <el-dialog
                :title="$t('TABLE_HEADER_MODIFY_RECORD')"
                visible
                width="50%"
                @close="onCancel">
            <el-table
                    stripe
                    :data="statusModifyTable"
                    style="width: 100%">
                <el-table-column
                        prop="modifyUserName"
                        :label="$t('SITE_TABLE_HEADER_MODIFIED_BY')"
                        width="180">
                </el-table-column>
                <el-table-column
                        prop="updateDate"
                        :label="$t('SITE_TABLE_HEADER_MODIFIED_TIME')"
                        width="150">
                    <template slot-scope="scope">
                        {{ scope.row.updateDate | formatDate }}
                    </template>
                </el-table-column>
                <el-table-column
                        prop="currentStatusName"
                        min-width="180"
                        show-overflow-tooltip
                        :label="$t('MODIFY_HEADER_AFTER')">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
              <el-button @click="onCancel">{{ $t('btn_close') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {dateFormat} from '@/utils'
    export default {
        name: "modifyRecord",
        data(){
            return {
            }
        },
        props: {
            statusModifyTable: Array,
            onCancel: Function
        },
        filters: {
            formatDate: value => {
                if (value != null) {
                    return dateFormat(new Date(value))
                } else {
                    return value;
                }
            }
        },
    }
</script>

<style scoped>

</style>